
import * as glideRuntime$Jwa3ZC4y2ZpeTvlTPq1UI_45bADXPBa1L3IV7ys7HHSyU from '/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/node_modules/@nuxt/image/dist/runtime/providers/glide'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "glide",
  "domains": [
    "\"api.prix-de-gros.com",
    "prix-de-gros.com",
    "www.prix-de-gros.com\""
  ],
  "alias": {
    "/api": "/api",
    "/static": "https://www.prix-de-gros.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['glide']: { provider: glideRuntime$Jwa3ZC4y2ZpeTvlTPq1UI_45bADXPBa1L3IV7ys7HHSyU, defaults: {"baseURL":"https://api.prix-de-gros.com/glide/"} }
}
        